module.exports = __webpack_public_path__ + "img/bgc.b53e6b75.png";